import './styles.scss';

document.querySelectorAll('.open-newsletter',).forEach((button,) => {
  button.addEventListener('click', () => {
    document.querySelector('.modal-newsletter',).classList.add('modal--active',);
  },);
},);

document.addEventListener('click', (event,) => {
  if (event.target.classList.contains('modal-newsletter',) || event.target.classList.contains('modal__close',)) {    
    document.querySelector('.modal-newsletter',).classList.remove('modal--active',);
  }
},);
